module.exports = __webpack_public_path__ + "static/MacBookPro3-33707f925974e42654833abe8ea78a42.png";